import {
  ACCESS_TOKEN_COOKIE_NAME,
  REFRESH_TOKEN_COOKIE_NAME,
} from "muminsmart-utils";

export const AUTH_USER_COOKIE_NAME = "auth_user";

const getCookieMaxAgeSeconds = (token: string): number => {
  try {
    const payload = JSON.parse(
      Buffer.from(token.split(".")[1], "base64url").toString(),
    ) as { exp?: number };

    if (payload.exp) {
      return Math.max(0, payload.exp - Math.floor(Date.now() / 1000));
    }
  } catch {
    // Fall through to default max age.
  }

  return 3600;
};

export const getAuthCookieOptions = (maxAgeSeconds: number) => ({
  httpOnly: true,
  secure: process.env.NODE_ENV === "production",
  sameSite: "lax" as const,
  path: "/",
  maxAge: maxAgeSeconds,
});

export const buildAuthCookieHeader = (
  accessToken?: string,
  refreshToken?: string,
): string | undefined => {
  const parts: string[] = [];

  if (accessToken) {
    parts.push(`${ACCESS_TOKEN_COOKIE_NAME}=${accessToken}`);
  }

  if (refreshToken) {
    parts.push(`${REFRESH_TOKEN_COOKIE_NAME}=${refreshToken}`);
  }

  return parts.length > 0 ? parts.join("; ") : undefined;
};

export { getCookieMaxAgeSeconds };
